"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateHexadecimal = validateHexadecimal;
exports.validateURL = validateURL;
exports.validateNumber = validateNumber;
exports.validateIntegerFun = validateIntegerFun;
exports.validateInteger = validateInteger;
exports.validatePort = validatePort;
exports.validateLowerCase = validateLowerCase;
exports.validateUpperCase = validateUpperCase;
exports.validatAlphabets = validatAlphabets;
exports.validIpWidthMask = validIpWidthMask;
exports.validMacWidthMask = validMacWidthMask;
exports.validMac = validMac;
exports.validateIp = validateIp;
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.parse-float.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.array.last-index-of.js");

var _lodash = _interopRequireDefault(require("lodash"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _locale = require("sk-ui/lib/locale");

var _util = require("sk-ui/lib/utils/util");

var _component = _interopRequireDefault(require("./component"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _errorMessageTemplate = _interopRequireDefault(require("./error-message-template"));

var _rules = _interopRequireDefault(require("./rules"));

var installed = false;
var ElFormItemComponent;
var validator = {
  nameReg: /^(\w|[\u4E00-\u9FA5]|-)*$/,
  // emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // emailReg: /^\w[-\\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\\.)+[A-Za-z]{2,14}$/,
  emailReg: /^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/,
  ipAddrReg: /^(?:(?:1[0-9][0-9]\.)|(?:2[0-4][0-9]\.)|(?:25[0-5]\.)|(?:[1-9][0-9]\.)|(?:[0-9]\.)){3}(?:(?:1[0-9][0-9])|(?:2[0-4][0-9])|(?:25[0-5])|(?:[1-9][0-9])|(?:[0-9]))$/,
  ipWithMaskReg: /(^(?:(?:1[0-9][0-9]\.)|(?:2[0-4][0-9]\.)|(?:25[0-5]\.)|(?:[1-9][0-9]\.)|(?:[0-9]\.)){3}(?:(?:1[0-9][0-9])|(?:2[0-4][0-9])|(?:25[0-5])|(?:[1-9][0-9])|(?:[0-9]))\/([1-9]|[1-2]\d|3[0-2])$)|(0.0.0.0\/0)/,
  macReg: /^[A-Fa-f0-9]{2}(:[A-Fa-f0-9]{2}){5}$/,
  macWithMaskReg: /^[A-Fa-f0-9]{2}(:[A-Fa-f0-9]{2}){5}\/[A-Fa-f0-9]{2}(:[A-Fa-f0-9]{2}){5}$/,
  portReg: /^([1-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
  commonNameReg: /^[0-9a-zA-Z\u4e00-\u9fa5\.\-@]{1}[0-9a-zA-Z\u4e00-\u9fa5\.\-_@]*$/,
  disabledNamed: /^(?!.?(?:admin|special)).*$/,
  integer: /^[-\+]?\d+$/,
  number: /^[-\\+]?[0-9]+\.?[0-9]*$/,
  numberSub: /^[-+]?0\d/,
  port: /^([1-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  spRegexp: /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
  // 大写字母，小写字母，数字，特殊符号中四选三组合，其中特殊字符包括英文半角下 `~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]\s (\s表示空格)
  charAndNumReg: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]\s]+$)(?![a-z0-9]+$)(?![a-z`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]\s]+$)(?![0-9`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]\s]+$)[a-zA-Z0-9`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]\s]+$/,
  // 大写字母，小写字母，数字，特殊符号都要有，其中特殊字符包括英文半角下 `~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]\s (\s表示空格)
  hardLevelPwdReg: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]\s]).+$/
};
var exp = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (installed) {
      return;
    }

    installed = true;
    ElFormItemComponent = options.FormItemComponent || Vue.component('ElFormItem');

    if (!ElFormItemComponent) {
      throw Error('please install element-ui first');
    }

    _errorMessage["default"].setTemplate(options.errorMessageTemplate || _errorMessageTemplate["default"]);

    _component["default"].fieldChange = options.fieldChange || 'verify';
    ElFormItemComponent.mixin(_component["default"]);
    init();
  },
  addRule: function addRule(name, getter) {
    if (!installed) {
      throw Error('please install me');
    }

    var props = {};

    if (typeof name === 'string') {
      props[name] = {};
    } else {
      props[name.name] = name;
    }

    var _name = typeof name === 'string' ? name : name.name;

    var component = {
      props: props
    }; // 监听prop变化，触发校验

    component.watch = {};

    component.watch[_name] = function () {
      if (this.verify !== undefined && this.prop) {
        this.validate('');
      }
    };

    ElFormItemComponent.mixin(component);
    return (0, _rules["default"])(_name, getter);
  },
  getRule: function getRule(name) {
    return (0, _rules["default"])(name);
  },
  getErrorMessage: function getErrorMessage(name, templateData) {
    return _errorMessage["default"].get(name, templateData);
  }
};

function normalValue(value) {
  var _value;

  if (value && _lodash["default"].isNumber(value.size) && value.name && _lodash["default"].isNumber(value.origSize)) {
    _value = value.name;
  } else if (_lodash["default"].isString(_value)) {
    _value = _value.replace(validator.spRegexp, '_').length;
  } else {
    _value = value;
  }

  return _value;
}

function validateCommonNameReg(rule, value, callback) {
  var _value = normalValue(value);

  if (_value) {
    validator.commonNameReg.test(_value) ? callback() : callback(new Error());
  } else {
    callback();
  }
}

function validateNotEmpty(rule, value, callback, message) {
  var _value = normalValue(value);

  if ((0, _util.isEmptyObj)(_value)) {
    callback(new Error(message));
  } else if (_lodash["default"].isArray(_value) && _value.length === 0) {
    callback(new Error(message));
  } else if (_lodash["default"].isPlainObject(_value) && (0, _util.isEmptyObj)(_value.id)) {
    callback(new Error(message));
  } else if (_lodash["default"].isString(_value) && _value.trim() === '') {
    callback(new Error((0, _locale.t)('sk.form.common_empty_string_valid')));
  } else {
    callback();
  }
}

function validatePassword(rule, value, callback) {
  var _value = normalValue(value);

  if ((0, _util.isEmptyObj)(_value)) {
    callback(new Error((0, _locale.t)('sk.form.common_term_password_null_valid')));
  } else if (_lodash["default"].isString(_value) && (_value.length < 8 || _value.length > 16)) {
    callback(new Error((0, _locale.t)('sk.form.common_term_length_valid', {
      min: 8,
      max: 16
    })));
  } else if (_lodash["default"].isString(_value) && _value.trim() === '') {
    callback(new Error((0, _locale.t)('sk.form.common_empty_string_valid')));
  } else if (_lodash["default"].isString(_value) && !validator.charAndNumReg.test(_value)) {
    callback(new Error((0, _locale.t)('sk.form.common_charAndNum_string_valid')));
  } else {
    callback();
  }
}

function validateCommonPassword(rule, value, callback) {
  var _value = normalValue(value);

  if ((0, _util.isEmptyObj)(_value)) {
    callback(new Error((0, _locale.t)('sk.form.common_term_password_null_valid')));
  } else if (_lodash["default"].isString(_value) && (_value.length < 8 || _value.length > 32)) {
    callback(new Error((0, _locale.t)('sk.form.common_term_length_valid', {
      min: 8,
      max: 32
    })));
  } else if (_lodash["default"].isString(_value) && _value.trim() === '') {
    callback(new Error((0, _locale.t)('sk.form.common_empty_string_valid')));
  } else if (_lodash["default"].isString(_value) && !validator.charAndNumReg.test(_value)) {
    callback(new Error((0, _locale.t)('sk.form.common_charAndNum_string_valid')));
  } else {
    callback();
  }
}

function validateEasyLevelPassword(rule, value, callback) {
  var _value = normalValue(value);

  if ((0, _util.isEmptyObj)(_value)) {
    callback(new Error((0, _locale.t)('sk.form.common_term_password_null_valid')));
  } else if (_lodash["default"].isString(_value) && (_value.length < 6 || _value.length > 32)) {
    callback(new Error((0, _locale.t)('sk.form.common_term_length_valid', {
      min: 6,
      max: 32
    })));
  } else if (_lodash["default"].isString(_value) && _value.trim() === '') {
    callback(new Error((0, _locale.t)('sk.form.common_empty_string_valid')));
  } else {
    callback();
  }
}

function validateHardLevelPassword(rule, value, callback) {
  var _value = normalValue(value);

  if ((0, _util.isEmptyObj)(_value)) {
    callback(new Error((0, _locale.t)('sk.form.common_term_password_null_valid')));
  } else if (_lodash["default"].isString(_value) && (_value.length < 8 || _value.length > 32)) {
    callback(new Error((0, _locale.t)('sk.form.common_term_length_valid', {
      min: 8,
      max: 32
    })));
  } else if (_lodash["default"].isString(_value) && _value.trim() === '') {
    callback(new Error((0, _locale.t)('sk.form.common_empty_string_valid')));
  } else if (_lodash["default"].isString(_value) && !validator.hardLevelPwdReg.test(_value)) {
    callback(new Error((0, _locale.t)('sk.form.common_hard_passowrd_string_valid')));
  } else {
    callback();
  }
} // 验证名称长度


function validateRange(rule, value, callback) {
  var _value = normalValue(value);

  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number'; // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  // var spRegexp = validator.spRegexp;

  var val = _value; // var key = null;
  // var num = typeof _value === 'number';

  var str = typeof _value === 'string';
  var arr = Array.isArray(_value);
  var file = value && _lodash["default"].isNumber(value.size) && value.name && _lodash["default"].isNumber(value.origSize) && !!rule.validaFileSize;

  if (arr) {
    val = _value.length;
  }

  if (file) {
    val = value.origSize;
  } else if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = _value.length;
  }

  if (len && val !== rule.len) {
    callback(new Error());
  } else if (min && !max && val < rule.min) {
    callback(new Error());
  } else if (max && !min && val > rule.max) {
    callback(new Error());
  } else if (min && max && (val < rule.min || val > rule.max)) {
    callback(new Error());
  } else {
    callback();
  }
} // function validarteNotEmpty(rule, value, callback) {
//   value = value && value.trim ? value.trim() : value;
//   if (isEmptyObj(value)) {
//     callback(new Error());
//   } else if (_.isArray(value) && value.length === 0) {
//     callback(new Error());
//   } else if (_.isPlainObject(value) && isEmptyObj(value.id)) {
//     callback(new Error());
//   } else {
//     callback();
//   }
// }
// 关键字过滤


function validateSensitiveName(rule, value, callback) {
  var valid_map = ['admin', 'public', 'local', 'guest'];

  if (valid_map.indexOf(value) !== -1) {
    callback(new Error());
  } else {
    callback();
  }
} // 十六进制


function validateHexadecimal(rule, value, callback) {
  if (value) {
    var HexadecimalReg = /^[0-9a-fA-F]{1,4}$/;
    HexadecimalReg.test(value) ? callback() : callback(new Error());
  } else {
    callback();
  }
}
/* 合法uri*/


function validateURL(textval) {
  var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}
/* 数字*/


function validateNumber(rule, value, callback) {
  value = String(value);

  if (validator.number.test(value)) {
    validator.numberSub.test(value) ? callback(new Error()) : callback();
    /*  */
  } else {
    callback(new Error());
  }
}

function validateIntegerFun(value) {
  var num = String(value);

  if (validator.integer.test(num)) {
    return !validator.numberSub.test(num);
  } else {
    return false;
  }
}
/* 整数 不包含科学计算法与后端保持一致*/


function validateInteger(rule, value, callback) {
  // let num = String(value);
  // // 如果是科学计算法数据，转为数字
  // // if (num.indexOf('e') >= 0) {
  // //   num = Number(num);
  // //   num = num.toLocaleString().replace(/[,]/g, '');
  // // }
  // if (validator.integer.test(num)) {
  //   validator.numberSub.test(num) ? callback(new Error()) : callback();
  // } else {
  //   callback(new Error());
  // }
  var flag = validateIntegerFun(value);

  if (flag) {
    callback();
  } else {
    callback(new Error());
  }
}
/* 端口号 */


function validatePort(rule, value, callback) {
  if (validator.port.test(value)) {
    callback();
  } else {
    callback(new Error());
  }
}
/* 小写字母*/


function validateLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}
/* 大写字母*/


function validateUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}
/* 大小写字母*/


function validatAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
/**
 * 带掩码的ip（xxx.xxx.xxx.xxx/xx）校验
 */


function validIpWidthMask(ip) {
  var reg = validator.ipWithMaskReg;
  return reg.test(ip);
}
/**
 * 带掩码的mac（xx:xx:xx:xx:xx:xx/xx:xx:xx:xx:xx:xx）校验
 */


function validMacWidthMask(mac) {
  var macWithMaskReg = validator.macWithMaskReg;
  return macWithMaskReg.test(mac);
}
/**
 * 不带掩码的mac（xx:xx:xx:xx:xx:xx）校验
 */


function validMac(mac) {
  var macReg = validator.macReg;
  return macReg.test(mac);
}

function ipRangeCheck(startIp, endIp, inputIp) {
  console.log(startIp, endIp, inputIp);

  if (!startIp || !endIp || !inputIp) {
    return false;
  }

  var startIps = startIp.split('.');
  var endIps = endIp.split('.');
  var inputIps = inputIp.split('.');

  if (startIps.length !== 4 || endIps.length !== 4 || inputIps.length !== 4) {
    return false;
  }

  var i = 0;
  var startIpValue = 0;
  var endIpValue = 0;
  var inputIpValue = 0;

  for (i = 0; i < 4; i = i + 1) {
    startIpValue = startIpValue * 256 + parseInt(startIps[i], 10);
    endIpValue = endIpValue * 256 + parseInt(endIps[i], 10);
    inputIpValue = inputIpValue * 256 + parseInt(inputIps[i], 10);
  }

  return inputIpValue >= startIpValue && inputIpValue <= endIpValue;
} // 掩码是否合法
// function maskValidator(ip) {
//   // try {
//   //   var data = ip.split('.');
//   //   if (data[0] === '' || data[1] === '' || data[2] === '' || data[3] === '') {
//   //     return false;
//   //   }
//   //   data[0] = parseInt(data[0], 10);
//   //   data[1] = parseInt(data[1], 10);
//   //   data[2] = parseInt(data[2], 10);
//   //   data[3] = parseInt(data[3], 10);
//   //   if (data[0] === 0 && data[1] === 0 && data[2] === 0 && data[3] === 0) {
//   //     return false;
//   //   }
//   //   if (data[3] > 248) {
//   //     return false;
//   //   }
//   //   var ip_binary = (data[0] + 256).toString(2).substring(1) +
//   //           (data[1] + 256).toString(2).substring(1) +
//   //           (data[2] + 256).toString(2).substring(1) +
//   //           (data[3] + 256).toString(2).substring(1);
//   //   if (ip_binary.indexOf('01') !== -1) {
//   //     return false;
//   //   } else {
//   //     return true;
//   //   }
//   // } catch (e) {
//   //   return false;
//   // }
// };
// 保留性ip地址，不可用


var KEEP_ADDRESS_SET = ['127', '0', '169.254']; // d类保留地址

for (var i = 224; i <= 239; i++) {
  KEEP_ADDRESS_SET.push(String(i));
} // e类保留地址


for (var _i = 240; _i <= 255; _i++) {
  KEEP_ADDRESS_SET.push(String(_i));
}

var SPECIAL_ADDRESS_SET = ['0.0.0.0', '255.255.255.255'];
var IPV4_TOKEN_COUNT = 4;
var IPV4_TOKEN_NUM_MAX = 3;
var IPV4_TOKEN_VALUE_MAX = 255;
var LEGAL_IPV4_MASK_SET = [];
LEGAL_IPV4_MASK_SET.push('128.0.0.0');
LEGAL_IPV4_MASK_SET.push('192.0.0.0');
LEGAL_IPV4_MASK_SET.push('224.0.0.0');
LEGAL_IPV4_MASK_SET.push('240.0.0.0');
LEGAL_IPV4_MASK_SET.push('248.0.0.0');
LEGAL_IPV4_MASK_SET.push('252.0.0.0');
LEGAL_IPV4_MASK_SET.push('254.0.0.0');
LEGAL_IPV4_MASK_SET.push('255.0.0.0');
LEGAL_IPV4_MASK_SET.push('255.128.0.0');
LEGAL_IPV4_MASK_SET.push('255.192.0.0');
LEGAL_IPV4_MASK_SET.push('255.224.0.0');
LEGAL_IPV4_MASK_SET.push('255.240.0.0');
LEGAL_IPV4_MASK_SET.push('255.248.0.0');
LEGAL_IPV4_MASK_SET.push('255.252.0.0');
LEGAL_IPV4_MASK_SET.push('255.254.0.0');
LEGAL_IPV4_MASK_SET.push('255.255.0.0');
LEGAL_IPV4_MASK_SET.push('255.255.128.0');
LEGAL_IPV4_MASK_SET.push('255.255.192.0');
LEGAL_IPV4_MASK_SET.push('255.255.224.0');
LEGAL_IPV4_MASK_SET.push('255.255.240.0');
LEGAL_IPV4_MASK_SET.push('255.255.248.0');
LEGAL_IPV4_MASK_SET.push('255.255.252.0');
LEGAL_IPV4_MASK_SET.push('255.255.254.0');
LEGAL_IPV4_MASK_SET.push('255.255.255.0');
LEGAL_IPV4_MASK_SET.push('255.255.255.128');
LEGAL_IPV4_MASK_SET.push('255.255.255.192');
LEGAL_IPV4_MASK_SET.push('255.255.255.224');
LEGAL_IPV4_MASK_SET.push('255.255.255.240');
LEGAL_IPV4_MASK_SET.push('255.255.255.248');
LEGAL_IPV4_MASK_SET.push('255.255.255.252');
LEGAL_IPV4_MASK_SET.push('255.255.255.254');
LEGAL_IPV4_MASK_SET.push('255.255.255.255');
/* 验证ip地址合法性
  right: 正确
  error：不正确
  unavailabled：不可用
*/

function validateIp(value) {
  var onlyFormatCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!value) {
    return 'right';
  } // 纯IP格式校验


  if (!validator.ipAddrReg.test(value)) {
    return 'error';
  } // 业务性校验，包括过滤保留性ip地址、d类保留地址、e类保留地址 等等


  if (!onlyFormatCheck) {
    for (var index = 0; index < KEEP_ADDRESS_SET.length; index++) {
      var startIp = KEEP_ADDRESS_SET[index];

      if (value.indexOf(startIp) === 0) {
        return 'unavailabled';
      }
    }

    if (_lodash["default"].includes(SPECIAL_ADDRESS_SET, value)) {
      return 'unavailabled';
    }

    var ipSplitArr = value.split('.');

    if (IPV4_TOKEN_COUNT !== ipSplitArr.length) {
      return 'error';
    }

    for (var _index = 0; _index < ipSplitArr.length; _index++) {
      var nextToken = ipSplitArr[_index]; // if (!_.isInteger(nextToken)) {
      //   callback(new Error('请输入正确的ip地址'));
      //   valid = false;
      //   break;
      // }

      if (nextToken.length > IPV4_TOKEN_NUM_MAX) {
        return 'unavailabled';
      }

      if (nextToken === '0') {
        continue;
      }

      if (nextToken.indexOf('0') === 0) {
        return 'error';
      }

      if (nextToken.length < IPV4_TOKEN_NUM_MAX) {
        continue;
      }

      var num = parseInt(nextToken, 10);

      if (num > IPV4_TOKEN_VALUE_MAX) {
        return 'error';
      }
    }
  }

  return 'right';
}

function validateIpRule(rule, value, callback) {
  var cb = validateIp(value);

  switch (cb) {
    case 'right':
      callback();
      break;

    case 'error':
      callback(new Error(exp.getErrorMessage('rightIp')));
      break;

    case 'unavailabled':
      callback(new Error(exp.getErrorMessage('availableIp')));
      break;

    default:
      callback();
  }
} // 掩码合法性验证


function maskValidator(value) {
  if (_lodash["default"].includes(LEGAL_IPV4_MASK_SET, value)) {
    return true;
  } else {
    return false;
  }
} // IP是否在子网内
// function subnetValidator(ip, mask, subnet) {
//   try {
//     if (ip === subnet) {
//       return false;
//     }
//     var ipData = ip.split('.');
//     var maskData = mask.split('.');
//     var subnetData = subnet.split('.');
//     if ((parseInt(ipData[0], 10) & parseInt(maskData[0], 10)) === parseInt(subnetData[0], 10) &&
//             (parseInt(ipData[1], 10) & parseInt(maskData[1], 10)) === parseInt(subnetData[1], 10) &&
//             (parseInt(ipData[2], 10) & parseInt(maskData[2], 10)) === parseInt(subnetData[2], 10) &&
//             (parseInt(ipData[3], 10) & parseInt(maskData[3], 10)) === parseInt(subnetData[3], 10)) {
//       return true;
//     } else {
//       return false;
//     }
//   } catch (e) {
//     return false;
//   }
// };


function init() {
  // 关键字过滤
  exp.addRule({
    name: 'notEmpty',
    type: [Boolean, String, Object]
  }, function (arg) {
    return {
      required: true,
      validator: function validator(rule, val, callback) {
        var _message = '';

        if ((0, _isString["default"])(arg)) {
          _message = (0, _locale.t)('sk.form.common_term_null_pre_valid') + (0, _locale.t)(arg);
        } else if ((0, _isObject["default"])(arg)) {
          _message = (0, _locale.t)(arg.message);
        } else {
          _message = (0, _locale.t)('sk.form.common_term_null_valid');
        }

        validateNotEmpty(rule, val, callback, _message);
      }
    };
  });
  exp.addRule('password', function (message) {
    return {
      required: true,
      validator: validatePassword
    };
  });
  exp.addRule('easyPassword', function (message) {
    return {
      required: true,
      validator: validateEasyLevelPassword
    };
  });
  exp.addRule('commonPassword', function (message) {
    return {
      required: true,
      validator: validateCommonPassword
    };
  });
  exp.addRule('hardPassword', function (message) {
    return {
      required: true,
      validator: validateHardLevelPassword
    };
  });
  exp.addRule({
    name: 'length',
    type: Number
  }, function (length) {
    return {
      len: length,
      message: exp.getErrorMessage('length', length)
    };
  }); // 最小文本长度

  exp.addRule({
    name: 'minLength',
    type: Number
  }, function (minLength) {
    return {
      min: minLength,
      message: exp.getErrorMessage('minLength', minLength)
    };
  }); // 数字类型

  exp.addRule('number', function () {
    return {
      validator: validateNumber,
      message: exp.getErrorMessage('number')
    };
  }); // 整数类型

  exp.addRule('port', function () {
    return {
      validator: validatePort,
      message: exp.getErrorMessage('port')
    };
  }); // :gt="11"

  exp.addRule({
    name: 'gt',
    type: Number
  }, function (gt) {
    return [exp.getRule('number')(), {
      validator: function validator(rule, val, callback) {
        val = parseFloat(val, 10);

        if (val <= gt) {
          callback(Error(exp.getErrorMessage('gt', gt)));
        } else {
          callback();
        }
      }
    }];
  }); // 整数类型

  exp.addRule('int', function () {
    return {
      validator: validateInteger,
      message: exp.getErrorMessage('int')
    };
  }); // gte

  exp.addRule({
    name: 'gte',
    type: Number
  }, function (gte) {
    return [exp.getRule('number')(), {
      validator: function validator(rule, val, callback) {
        val = parseFloat(val, 10);

        if (val < gte) {
          callback(Error(exp.getErrorMessage('gte', gte)));
        } else {
          callback();
        }
      }
    }];
  }); // lt

  exp.addRule({
    name: 'lt',
    type: Number
  }, function (lt) {
    return [exp.getRule('number')(), {
      validator: function validator(rule, val, callback) {
        val = parseFloat(val, 10);

        if (val >= lt) {
          callback(Error(exp.getErrorMessage('lt', lt)));
        } else {
          callback();
        }
      }
    }];
  }); // lte

  exp.addRule({
    name: 'lte',
    type: Number
  }, function (lte) {
    return [exp.getRule('number')(), {
      validator: function validator(rule, val, callback) {
        val = parseFloat(val, 10);

        if (val > lte) {
          callback(Error(exp.getErrorMessage('lte', lte)));
        } else {
          callback();
        }
      }
    }];
  }); // range=[0,10,false,true]
  //  第一个参数是min  第二个参数是max ，第三个参数true >=  第四个参数 true  <=

  exp.addRule({
    name: 'range',
    type: Array
  }, function (arg) {
    var rules = [exp.getRule('number')()];
    var includeMin = arg[2] || true;
    var includeMax = arg[3] || true;
    var min = arg[0];
    var max = arg[1];

    if (includeMin) {
      rules.push(exp.getRule('gte')(min)[1]);
    } else {
      rules.push(exp.getRule('gt')(min)[1]);
    }

    if (includeMax) {
      rules.push(exp.getRule('lte')(max)[1]);
    } else {
      rules.push(exp.getRule('lt')(max)[1]);
    }

    return rules;
  }); //  第一个参数startIp, endIp, inputIp

  exp.addRule({
    name: 'ipRangeCheck',
    type: Array
  }, function (arg) {
    var rules = [exp.getRule('iPv4Address')()];
    rules.push({
      validator: function validator(rule, val, callback) {
        if (!ipRangeCheck(arg[0], arg[1], val)) {
          callback(Error(exp.getErrorMessage('ipRangeCheck')));
        } else {
          callback();
        }
      }
    });
    return rules;
  }); //  子网掩码验证

  exp.addRule('mask', function (arg) {
    var rules = [// exp.getRule('iPv4Address')()
    ];
    rules.push({
      validator: function validator(rule, val, callback) {
        if (!maskValidator(val)) {
          callback(Error(exp.getErrorMessage('mask')));
        } else {
          callback();
        }
      }
    });
    return rules;
  }); // 最多小数位
  // exp.getRule('number')(),

  exp.addRule({
    name: 'maxDecimalLength',
    type: Number
  }, function (maxDecimalLength) {
    return {
      validator: function validator(rule, val, callback) {
        var decimal = val.toString().split('.')[1];

        if (decimal && decimal.length > maxDecimalLength) {
          callback(Error(exp.getErrorMessage('maxDecimalLength', maxDecimalLength)));
        } else {
          callback();
        }
      }
    };
  }); // 手机号

  exp.addRule('cellPhone', function () {
    return {
      pattern: /^((1[3-9][0-9])+\d{8})$/,
      message: exp.getErrorMessage('phone')
    };
  }); // exp.addRule('textMedium', () => ({
  //   max: 128,
  //   validateRange
  //   message: t('sk.form.common_term_maxlength_valid', {max: 128})
  // }));

  exp.addRule('textMedium', function () {
    return {
      max: 128,
      validator: validateRange,
      message: (0, _locale.t)('sk.form.common_term_maxlength_valid', {
        max: 128
      })
    };
  });
  exp.addRule({
    name: 'fileSize',
    type: Object
  }, function (arg) {
    var rule = {
      validator: validateRange,
      validaFileSize: true,
      message: arg.errorMessage ? (0, _locale.t)(arg.errorMessage) : (0, _locale.t)('sk.form.common_term_file_size_valid')
    };
    Object.assign(rule, arg);
    return rule;
  });
  exp.addRule('textShort', function () {
    return {
      max: 32,
      message: (0, _locale.t)('sk.form.common_term_maxlength_valid', {
        max: 32
      })
    };
  });
  exp.addRule('textName', function () {
    return {
      // pattern: validator.commonNameReg,
      validator: validateCommonNameReg,
      message: exp.getErrorMessage('textName')
    };
  });
  exp.addRule({
    name: 'email',
    type: [Boolean, Object]
  }, function (arg) {
    var _arg = Object.assign({
      length: 64,
      num: 1
    }, arg);

    function valid(callback, value) {
      if (value.length > _arg.length) {
        callback(new Error((0, _locale.t)('sk.form.common_term_maxlength_valid', {
          max: _arg.length
        })));
        return false;
      }

      if (!validator.emailReg.test(value)) {
        callback(new Error(exp.getErrorMessage('email')));
        return false;
      }

      return true;
    }

    return {
      validator: function validator(rule, value, callback) {
        // 单个邮箱校验
        if ((0, _util.isEmptyObj)(value)) {
          callback();
        } else {
          var isValid = true;

          if (_lodash["default"].isBoolean(arg)) {
            isValid = valid(callback, value);
          } else if (_arg.num >= 1) {
            if (!_lodash["default"].isArray(value)) {
              throw new Error('email type must be array');
            }

            if (value.length > _arg.num) {
              callback(new Error(exp.getErrorMessage('num', _arg.num)));
            }

            for (var index = 0; index < value.length; index++) {
              var email = value[index];
              isValid = valid(callback, email) && isValid;

              if (!isValid) {
                break;
              }
            }
          }

          if (isValid) {
            callback();
          }
        }
      }
    };
  }); // // 邮箱
  // exp.addRule('email', () => ({
  //   pattern: validator.emailReg,
  //   message: exp.getErrorMessage('email')
  // }));
  // 6位数字验证码

  exp.addRule('verifyCode', function () {
    return {
      pattern: /^\d{6}$/,
      message: exp.getErrorMessage('verifyCode')
    };
  }); // ip 不仅对ip格式上校验，而且业务上限制

  exp.addRule('iPv4Address', function () {
    return {
      // pattern: validator.ipAddrReg,
      validator: validateIpRule // message: t('sk.form.common_term_ip_valid')

    };
  }); // 关键字过滤

  exp.addRule('sensitiveName', function () {
    return {
      message: (0, _locale.t)('sk.form.common_disabled_named_valid'),
      validator: validateSensitiveName
    };
  }); // 64位
  // exp.addRule('longLength', () => ({
  //   max: 64,
  //   message: t('sk.form.common_term_maxlength_valid', { max: 64 })
  // }));

  exp.addRule('longLength', function () {
    return {
      max: 64,
      validator: validateRange,
      message: (0, _locale.t)('sk.form.common_term_maxlength_valid', {
        max: 64
      })
    };
  }); // 32位

  exp.addRule('middleLength', function () {
    return {
      max: 32,
      message: (0, _locale.t)('sk.form.common_term_maxlength_valid', {
        max: 32
      })
    };
  }); // 8位

  exp.addRule('shortLength', function () {
    return {
      max: 8,
      message: (0, _locale.t)('sk.form.common_term_maxlength_valid', {
        max: 8
      })
    };
  }); // url

  exp.addRule('url', function () {
    return {
      message: (0, _locale.t)('sk.form.common_term_url_valid'),
      validator: validateURL
    };
  }); // 大写字母

  exp.addRule('validateUpperCase', function () {
    return {
      message: (0, _locale.t)('sk.form.common_term_uppercase_valid'),
      validator: validateUpperCase
    };
  }); // 小写字母

  exp.addRule('validateLowerCase', function () {
    return {
      message: (0, _locale.t)('sk.form.common_term_lowercase_valid'),
      validator: validateLowerCase
    };
  }); // 十六进制

  exp.addRule('hexadecimalNumber', function () {
    return {
      message: (0, _locale.t)('sk.form.common_hexadecimal_number_valid'),
      validator: validateHexadecimal
    };
  });
  exp.addRule({
    name: 'suffix',
    type: Object
  }, function (suffix, form, curFormItem) {
    return {
      validator: function validator(rule, val, callback) {
        if (val) {
          var _value = normalValue(val);

          var resultList = suffix.includeSuffixes.map(function (includeSuffix) {
            var regexp = new RegExp("^".concat(includeSuffix, "$"));

            var index = _value.lastIndexOf(includeSuffix);

            return index !== -1 && regexp.test(_value.substring(index));
          }).filter(function (item) {
            return item;
          });
          var hasPass = resultList && resultList.length > 0;

          if (hasPass) {
            callback();
          } else {
            callback(new Error((0, _locale.t)(suffix.errorMessage) || curFormItem.errorMessage));
          }
        } else {
          callback();
        }
      }
    };
  });
}

var _default = exp;
exports["default"] = _default;